// @ts-nocheck
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

const FocusSettingsContext = React.createContext({ ttsOnFocusEnabled: true });

export const FocusSettingsProvider = ({ children, enableTTSOnFocus }) => {
  return (
    <FocusSettingsContext.Provider
      value={{ ttsOnFocusEnabled: enableTTSOnFocus }}
    >
      {children}
    </FocusSettingsContext.Provider>
  );
};

FocusSettingsProvider.propTypes = {
  children: PropTypes.node,
  enableTTSOnFocus: PropTypes.bool,
};

FocusSettingsProvider.defaultProps = {
  children: null,
  enableTTSOnFocus: true,
};

export const FocusSettingsConsumer = ({ children }) => {
  return (
    <FocusSettingsContext.Consumer>
      {value => children(value)}
    </FocusSettingsContext.Consumer>
  );
};

FocusSettingsConsumer.propTypes = {
  children: PropTypes.func,
};

FocusSettingsConsumer.defaultProps = {
  children: () => {},
};

export const withFocusSettings = Component => ({ ...rest }) => {
  return (
    <FocusSettingsConsumer>
      {value => <Component {...rest} {...value} />}
    </FocusSettingsConsumer>
  );
};

export const useFocusSettings = () => {
  return useContext(FocusSettingsContext);
};
